import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { Button as PaperButton } from 'react-native-paper';
import { GTFonts, useTheme } from '../../theme';
import { borderWidth, fs, s, v } from '../../utils/libs';

type SupplierPrerequisiteEmptyStateProps = {
  description: string;
  onAddSupplier: () => void;
};

const SupplierPrerequisiteEmptyState = ({
  description,
  onAddSupplier,
}: SupplierPrerequisiteEmptyStateProps) => {
  const { theme } = useTheme();

  return (
    <View
      style={[
        styles.container,
        {
          borderColor: theme.colors.text,
          borderRadius: theme.borderRadius.md,
          backgroundColor: theme.colors.surface,
        },
      ]}>
      <Text style={[styles.title, { color: theme.colors.text }]}>
        No suppliers yet
      </Text>
      <Text style={[styles.description, { color: theme.colors.textSecondary }]}>
        {description}
      </Text>
      <PaperButton
        mode="contained"
        onPress={onAddSupplier}
        style={[styles.button, { borderRadius: theme.borderRadius.md }]}
        contentStyle={styles.buttonContent}
        labelStyle={styles.buttonLabel}
        buttonColor={theme.colors.successDark}
        textColor="#fff"
        uppercase={false}>
        Add supplier
      </PaperButton>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    borderWidth: borderWidth(1),
    padding: s(16),
    gap: v(6),
  },
  title: {
    fontFamily: GTFonts.semibold,
    fontSize: fs(15),
    lineHeight: fs(20),
  },
  description: {
    fontFamily: GTFonts.regular,
    fontSize: fs(13),
    lineHeight: fs(18),
  },
  button: {
    alignSelf: 'flex-start',
    marginTop: v(6),
  },
  buttonContent: {
    height: v(40),
    paddingHorizontal: s(8),
  },
  buttonLabel: {
    fontFamily: GTFonts.semibold,
    fontSize: fs(14),
  },
});

export default SupplierPrerequisiteEmptyState;
